import AllTrackers from 'tracker/AllTrackers'
import ReactGA4 from 'react-ga4'
import { expandEnrichedEventData } from 'tracker/helpers'

/** TRACKING FOR PLUGINS - e.g. Growthbook */

/** GROWTHBOOK TRACKING */
export const trackGA4GrowthbookExperimentViewed = ({
  experimentId,
  variationId
}: {
  experimentId: string
  variationId: string
}) => {
  if (AllTrackers.getInstance().slerpGA4Tracker.isTrackingEnabled) {
    expandEnrichedEventData(AllTrackers.getInstance().slerpGA4Tracker, {
      [`${experimentId}_variation_id`]: variationId
    })
    ReactGA4.gtag('event', 'view_gb_experiment', {
      experiment_id: experimentId,
      variation_id: variationId,
      send_to: AllTrackers.getInstance().slerpGA4Tracker.trackingId
    })
  }
}
